const links = [
  {
    "name": "Debugging",
    "to": "/docs"
  },
  {
    "name": "Placeholder",
    "to": "/docs"
  },
  {
    "name": "Placeholder",
    "to": "/docs"
  },
  {
    "name": "Placeholder",
    "to": "/docs"
  },
  {
    "name": "Placeholder",
    "to": "/docs"
  },
  {
    "name": "Placeholder",
    "to": "/docs"
  },
  {
    "name": "Placeholder",
    "to": "/docs"
  }
]

export default links;
